import { Typography } from '@mui/material';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import * as Styled from './Reviews.styles';

const StarIcon = () => <Styled.Star src="/icons/star.svg" alt="" aria-hidden />;

const ReviewCard = ({ review }) => {
  const { t } = useTranslation();
  const lang = i18next.language;
  const { name, date, rating, reviewTitle, text } = review;
  const title = reviewTitle[lang] || reviewTitle.no;
  const body = text[lang] || text.no;

  return (
    <Styled.Card className="glass-border">
      {name && (
        <Styled.CardHeader>
          <Typography variant="h6">{name}</Typography>
          {date && <Typography variant="body14">{date}</Typography>}
        </Styled.CardHeader>
      )}

      <Styled.Stars
        aria-label={t('homeReviews.starsAriaLabel', { count: rating })}
      >
        {Array.from({ length: rating }).map((_, index) => (
          <StarIcon key={index} />
        ))}
      </Styled.Stars>

      <Typography variant="h6">{title}</Typography>
      <Typography variant="body16">{body}</Typography>
    </Styled.Card>
  );
};

export default ReviewCard;
